import React, { useState } from 'react';
import { Button, Divider, Sidebar } from 'semantic-ui-react';
import { fetchStageFormData } from './issues-slice';
import { fetchDocumentData } from '../document/documents-slice';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import CloseIcon from './CloseIcon';
import { useNavigate } from 'react-router-dom';

const prefix = 'approveSignatureSuccess';

export default function ApproveSignatureSuccess(props) {
  const [showModal, setShowModal] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const type = props.type;
  const handleSidebarClose = props.handleSidebarClose;
  const itemType = props.itemType;

  const itemAssignmentCode = useSelector((state) => state.auth.user.itemAssignmentCode);

  const handleApproval = () => {
    if (itemType === 'document') {
      dispatch(fetchDocumentData({ itemAssignmentCode, navigate }));
    } else {
      dispatch(fetchStageFormData({ itemAssignmentCode, navigate }));
    }
    handleSidebarClose();
    setShowModal(false);
  };

  const handleClose = () => {
    if (itemType === 'document') {
      dispatch(fetchDocumentData({ itemAssignmentCode, navigate }));
    } else {
      dispatch(fetchStageFormData({ itemAssignmentCode, navigate }));
    }
    handleSidebarClose();
    setShowModal(false);
  };

  const intl = useIntl();
  const translatedIssueType = intl.formatMessage({ id: `issueType.${type}`, defaultMessage: `${type}` });

  return (
    <div>
      <Sidebar animation="overlay" direction="right" width="very wide" visible={showModal} className="side-bar">
        <CloseIcon handleClose={handleClose} />
        <div className="signature-result-sidebar">
          <div className="header">
            <FormattedMessage
              id={`${prefix}.successfullyApproved`}
              defaultMessage={`You have successfully approved and signed your ${translatedIssueType}`}
              values={{ translatedIssueType }}
            />
          </div>
          <div className="sub-header">
            <FormattedMessage
              id={`${prefix}.downloadCopyInfo`}
              defaultMessage="Once all parties have executed it, you will receive an email with a copy of the document available for you to download"
            />
          </div>
          <Divider hidden />
          <Button className="ui green center button view-button" onClick={handleApproval}>
            <FormattedMessage
              id={`${prefix}.approveButton`}
              defaultMessage={`View ${translatedIssueType}`}
              values={{ translatedIssueType }}
            />
          </Button>
        </div>
      </Sidebar>
    </div>
  );
}
